import { ModelMixin } from '@app/models/core/base-generic.model';

export class Job extends ModelMixin<Job>() {
    // We use JobPosting ID to get the Indeed Job
    protected static _resource = 'applicantTracker/indeed/jobs';
    protected static _version = 'v2';
    protected static _type = 'indeedJobs';

    get status(): string {
        return this._attributes['status'];
    }

    get viewCount(): number | null {
        return this._attributes['viewCount'];
    }

    get publicUrl(): string | null {
        return this._attributes['publicUrl'];
    }
}
